import { FinanceType } from './ProductPricing';
import { ProgramType } from './ProgramTypes';

export const NewYorkCityStateOverride = 'NY-NYC';

export enum UtilityStatus {
  active = 'active',
  inactive = 'inactive',
}

export enum UtilityServiceType {
  electric = 'electric',
  gas = 'gas',
  water = 'water',
  sewer = 'sewer',
  trash = 'trash',
}

// Field names that can be validated in PTO confirmation extraction
export enum PtoConfirmationFieldName {
  utilityName = 'utilityName',
  ptoGrantedDate = 'ptoGrantedDate',
  customerFirstName = 'customerFirstName',
  customerLastName = 'customerLastName',
  customerAddressStreet = 'customerAddressStreet',
  customerAddressCity = 'customerAddressCity',
  customerAddressState = 'customerAddressState',
  customerAddressZipCode = 'customerAddressZipCode',
}

export const ptoConfirmationRequiredFieldNames: PtoConfirmationFieldName[] = Object.values(PtoConfirmationFieldName);

// Field names that can be validated in utility bill extraction
export enum UtilityBillFieldName {
  customerFirstName = 'customerFirstName',
  customerLastName = 'customerLastName',
  customerAddressStreet = 'customerAddressStreet',
  customerAddressCity = 'customerAddressCity',
  customerAddressState = 'customerAddressState',
  customerAddressZipCode = 'customerAddressZipCode',
  utilityName = 'utilityName',
  documentDate = 'documentDate',
}

export const utilityBillRequiredFieldNames: UtilityBillFieldName[] = [
  UtilityBillFieldName.customerFirstName,
  UtilityBillFieldName.customerLastName,
  UtilityBillFieldName.customerAddressStreet,
  UtilityBillFieldName.customerAddressCity,
  UtilityBillFieldName.customerAddressState,
  UtilityBillFieldName.customerAddressZipCode,
  UtilityBillFieldName.utilityName,
];

export interface UtilityRules {
  ptoConfirmationPostExtractAction?: {
    exclusions?: PtoConfirmationFieldName[];
  };
  utilityBillPostExtractAction?: { exclusions?: UtilityBillFieldName[] };
}

export interface UtilityDocument {
  lseId: number;
  name: string;
  state: string;
  status: UtilityStatus;
  contractType: FinanceType;
  programTypes?: ProgramType[];
  incentives?: IncentivesObject[];
  excludeFromAutoApproval?: boolean;
  aliases?: string[];
  rules?: UtilityRules;
}

export enum Incentives {
  illinoisShines = 'Illinois-Shines',
}

interface IncentivesObject {
  incentive: Incentives;
  rates?: {
    rate: number;
    systemSizekWACMax?: number;
    systemSizekWACMin?: number;
  }[];
}
